/**
 * @desc 库龄数据导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.StockAgeRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/stockPool/stockAgeExport`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
